import {Type} from "@angular/core";
import {PreguntasTipoEnum} from "@shared/enums";
import {
    TipoPreguntaDerivadorRandomComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-derivador-random/tipo-pregunta-derivador-random.component";
import {
    TipoPreguntaMatrizRangeComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-matriz-range/tipo-pregunta-matriz-range.component";
import {
    TipoPreguntaMatrizMultipleComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-matriz-multiple/tipo-pregunta-matriz-multiple.component";
import {
    TipoPreguntaMatrizSingleComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-matriz-single/tipo-pregunta-matriz-single.component";
import {
    TipoPreguntaMultipleComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-multiple/tipo-pregunta-multiple.component";
import {
    TipoPreguntaPuntosExtrasComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-puntos-extras/tipo-pregunta-puntos-extras.component";
import {
    TipoPreguntaRangoComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-rango/tipo-pregunta-rango.component";
import {
    TipoPreguntaSaltoCondicionadoComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-salto-condicionado/tipo-pregunta-salto-condicionado.component";
import {
    TipoPreguntaSingleComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-single/tipo-pregunta-single.component";
import {
    TipoPreguntaUrlComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-url/tipo-pregunta-url.component";
import {
    TipoPreguntaVacioComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-vacio/tipo-pregunta-vacio.component";
import {
    TipoPreguntaDistributionComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-distribution/tipo-pregunta-distribution.component";
import {
    TipoPreguntaDateSelectComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-date-select/tipo-pregunta-date-select.component";
import {
    TipoPreguntaRankingComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-ranking/tipo-pregunta-ranking.component";
import {
    TipoPreguntaComponent
} from "../../layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta/tipo-pregunta.component";
import { TipoPreguntaSeleccionImagenesComponent } from "src/app/layout/encuestas/encuestas-compartidos/encuesta-detalle-pregunta/tipos-preguntas/tipo-pregunta-seleccion-imagenes/tipo-pregunta-seleccion-imagenes.component";

export const tiposPreguntaMap = new Map<PreguntasTipoEnum, Type<TipoPreguntaComponent>>();

tiposPreguntaMap.set(PreguntasTipoEnum.SINGLE_CHOICE, TipoPreguntaSingleComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.MULTIPLE_CHOICE, TipoPreguntaMultipleComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.NUMERIC_IN_RANGE, TipoPreguntaRangoComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.TEXT, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.URL, TipoPreguntaUrlComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.VIDEO, TipoPreguntaUrlComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.PICTURE, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.INFO, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.MATRIX_SINGLE, TipoPreguntaMatrizSingleComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.MATRIX_MULTIPLE, TipoPreguntaMatrizMultipleComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.MATRIX_RANGE, TipoPreguntaMatrizRangeComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.EXTRA_POINTS, TipoPreguntaPuntosExtrasComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.NUMERIC_TEXT, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.FLOW_JUMP, TipoPreguntaSaltoCondicionadoComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.FLOW_RANDOM, TipoPreguntaDerivadorRandomComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.FLOW_CHECKPOINT, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.DISTRIBUTION, TipoPreguntaDistributionComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.SCANNER, TipoPreguntaVacioComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.DATE_SELECT, TipoPreguntaDateSelectComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.RANKING, TipoPreguntaRankingComponent);
tiposPreguntaMap.set(PreguntasTipoEnum.GRAPHICAL_CHOICE, TipoPreguntaSeleccionImagenesComponent);
